module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-image "
  }, [_c('router-link', {
    attrs: {
      "to": '/videos/' + _vm.video.id
    }
  }, [_c('figure', {
    staticClass: "image is-4by3"
  }, [_c('img', {
    attrs: {
      "src": _vm.video.thumbnail,
      "alt": ""
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('span', {
    staticClass: "content has-text-centered"
  }, [_c('h3', [_vm._v(_vm._s(_vm.video.title))])]), _vm._v(" "), _c('div', {
    staticClass: "tag-container"
  }, [_c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("Content:")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-primary"
  }, [_vm._v(_vm._s(_vm.video.content_area))])]), _vm._v(" "), _c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("Grade:")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-primary"
  }, [_vm._v(_vm._s(_vm.video.grade))])])]), _vm._v(" "), _vm._l((_vm.video.tags), function(tag) {
    return _c('span', {
      staticClass: "tag is-primary has-text-centered cftag"
    }, [_vm._v(_vm._s(tag.text))])
  })], 2), _vm._v(" "), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item"
  }, [_c('div', {
    staticClass: "editing-container"
  }, [(_vm.editing) ? _c('input', {
    staticClass: "button is-danger",
    attrs: {
      "type": "button",
      "value": "remove",
      "name": "remove"
    },
    on: {
      "click": function($event) {
        _vm.removeVideoFromLibrary(_vm.libraryID, _vm.video.id)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('input', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "value": "cancel",
      "name": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.editing = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.editing) ? _c('input', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "value": "edit",
      "name": "edit"
    },
    on: {
      "click": function($event) {
        _vm.editing = !_vm.editing
      }
    }
  }) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-4260687c"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LibraryVideo.vue
// module id = 1015
// module chunks = 0